// UserLocationOverlay.js
// Custom Overlay class for user location marker
// This eliminates React reconciliation and prevents flickering during manual panning

export const createUserLocationOverlayClass = (maps) => {
  class UserLocationOverlay extends maps.OverlayView {
    constructor(position, map) {
      super();
      this.position = position;
      this.div = null;
      this.setMap(map);
    }

    onAdd() {
      // Create the outer container
      const div = document.createElement('div');
      div.style.position = 'absolute';
      div.style.width = '20px';
      div.style.height = '20px';
      div.style.transform = 'translate(-50%, -50%)';
      div.style.pointerEvents = 'none'; // Don't block map interactions

      // Create pulsing outer circle
      const pulsingCircle = document.createElement('div');
      pulsingCircle.style.position = 'absolute';
      pulsingCircle.style.top = '50%';
      pulsingCircle.style.left = '50%';
      pulsingCircle.style.width = '20px';
      pulsingCircle.style.height = '20px';
      pulsingCircle.style.backgroundColor = 'rgba(66, 165, 245, 0.3)';
      pulsingCircle.style.borderRadius = '50%';
      pulsingCircle.style.transform = 'translate(-50%, -50%)';
      pulsingCircle.style.animation = 'userLocationPulse 2s infinite';

      // Create inner solid circle
      const innerCircle = document.createElement('div');
      innerCircle.style.position = 'absolute';
      innerCircle.style.top = '50%';
      innerCircle.style.left = '50%';
      innerCircle.style.width = '12px';
      innerCircle.style.height = '12px';
      innerCircle.style.backgroundColor = '#1976d2';
      innerCircle.style.border = '2px solid white';
      innerCircle.style.borderRadius = '50%';
      innerCircle.style.transform = 'translate(-50%, -50%)';
      innerCircle.style.boxShadow = '0 2px 4px rgba(0,0,0,0.3)';

      div.appendChild(pulsingCircle);
      div.appendChild(innerCircle);

      this.div = div;

      // Add to overlay pane
      const panes = this.getPanes();
      panes.overlayMouseTarget.appendChild(div);
    }

    draw() {
      if (!this.div) return;

      const overlayProjection = this.getProjection();
      if (!overlayProjection) return;

      // Convert lat/lng to pixel position
      const pos = overlayProjection.fromLatLngToDivPixel(
        new window.google.maps.LatLng(this.position.lat, this.position.lng)
      );

      if (pos) {
        this.div.style.left = pos.x + 'px';
        this.div.style.top = pos.y + 'px';
      }
    }

    onRemove() {
      if (this.div) {
        this.div.parentNode.removeChild(this.div);
        this.div = null;
      }
    }

    updatePosition(newPosition) {
      this.position = newPosition;
      this.draw();
    }
  }

  return UserLocationOverlay;
};